import Document from './Document.view';

export default Document;
